export const environment = {
  production: false,
  staging: true,
  apiUrl:'https://rumv2-api-dev-linux-dkh3e2hebmcpaudq.eastus-01.azurewebsites.net',
  erpUiUrl: 'https://dev-erp.thh-llc.com',
  tesUiUrl: 'https://dev-tes.thh-llc.com',
  emsUiUrl: 'https://dev-ems.thh-llc.com/auth/login',
  rumUiUrl: 'https://dev-rum.thh-llc.com/token-login',
  itrackUiUrl: 'https://dev-itrack.thh-llc.com/app/dashboard',
  pulseUiUrl: 'https://project-pulse-staging.thh-llc.com',
};
